import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { BillsTableRow } from '../../types/billsTableRow'
import { isBillsTableFieldSuggestion } from '../../utils/isBillsTableFieldSuggestion'
import { BillsTableNoDataField } from '../BillsTableNoDataField'
import { BillsTableSuggestedField } from '../BillsTableSuggestedField'

interface BillsTableSupplierCellProps {
  row: BillsTableRow
}

export const BillsTableSupplierCell = ({ row }: BillsTableSupplierCellProps): ReactElement => {
  if (isBillsTableFieldSuggestion(row.supplier) && row.supplier.suggestion !== '') {
    return <BillsTableSuggestedField value={row.supplier.suggestion} />
  }

  if (row.supplier.actual === null || row.supplier.actual === '') {
    return <BillsTableNoDataField />
  }

  return <Typography.Text>{row.supplier.actual}</Typography.Text>
}
